import React from "react"
import { Link } from "react-router-dom"
import { KTSVG, toAbsoluteUrl } from "../../../../_metronic/helpers"
import './ListTable.css'

type Props = {
    isAdmin: boolean | undefined,
    influencers: any[] | undefined,
    isLoading: boolean,
    handleSMSSent: (requestId: string) => void
}


const ListTable: React.FC<Props> = ({isAdmin, influencers, isLoading, handleSMSSent}) => {
  

const getStatus = (influencer: any) => {
  switch(influencer.RequestStatus) {
    case 'N':
      return 'Yeni Kayıt'
    case 'W':
      return 'KVKK Onayı Bekleniyor'
    case 'A':
      return 'KVKK Onayı Verilmiş'
    default:
      return '-'
  }
}


let i = 0;

return (<>
        <div className='table-responsive'>

          {/* begin::Table */}
          <table className='table align-middle gs-0 gy-4'>

            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                <th className='text-dark ps-4 min-w-80px rounded-start text-center'>#</th>
                <th className='text-dark min-w-150px'>Adı</th>
                <th className='text-dark min-w-125px'>Soyadı</th>
                <th className='text-dark min-w-150px'>Cep No</th>
                {isAdmin && <th className='text-dark min-w-150px'>Kullanıcı</th>}
                <th className='text-dark min-w-150px'>Durum</th>
                <th className='text-dark min-w-100px'>Geçerlilik Süresi</th>
                {!isAdmin && <th className='text-dark min-w-200px text-end rounded-end'></th>}
              </tr>
            </thead>
            {/* end::Table head */}

            {/* begin::Table body */}
            <tbody>{
              isLoading ? <tr><td colSpan={6}><h1 className='text-center'>Yükleniyor...</h1></td></tr> : 
              (influencers && influencers.map((influencer: any, index: number) => {
                
                let smsDisplay = influencer.RequestStatus !== 'A' ? "block" : "none"
                let statusColor = influencer.RequestStatus === "A" ? 'success' : influencer.RequestStatus === "W" ? 'warning' : influencer.RequestStatus === "N" ? 'primary' : 'secondary'
                if(influencer && influencer.Name && influencer.Surname && influencer.MobilePhoneNumber ) {
                  i++
                  return (<tr key={i}>
                    <td className='text-center'>
                      <span className='text-dark fw-bold mb-1 fs-4'>{i}</span>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <Link 
                          className='symbol symbol-50px me-5'
                          to={`/customer/${influencer.RequestId}`}
                          key={'customer'}
                        >
                          <img
                            src={toAbsoluteUrl('/media/logos/influencer.png')}
                            className='grow cursor-pointer'
                            alt=''
                          />
                          </Link>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='text-dark fw-bold mb-1 fs-6'>{influencer.Name}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className='text-muted fw-semibold d-block mb-1 fs-6'>{influencer.Surname}</span>
                    </td>
                    <td>
                      <span className='text-muted fw-semibold d-block mb-1 fs-7'>{influencer.MobilePhoneNumber}</span>
                    </td>
                    {isAdmin && <td>
                      <span className='text-muted fw-semibold d-block mb-1 fs-7'>{influencer.SalesPersonUserName}</span>
                    </td>}
                    <td>
                      <span className={`badge badge-light-${statusColor} fs-7 fw-semibold`}>
                        {getStatus(influencer)}
                      </span>
                    </td>
                    <td className="text-center">
                      <span className='badge badge-light-info fs-7 fw-semibold '>
                        {10 - parseInt(influencer.GecerlilikSüresi) || '-'}
                      </span>
                    </td>
                    {!isAdmin &&  <td className='text-end'>
                      <button 
                        className='btn btn-bg-primary btn-active-color-success bg-hover-success btn-sm me-1 text-light'
                        style={{display: smsDisplay}}
                        onClick={() => {handleSMSSent(influencer.RequestId)}}
                      >
                        <KTSVG path='/media/icons/duotune/general/gen16.svg' className='svg-icon-3' />
                        SMS Gönder
                      </button>
                    </td>}
                  </tr>)}
              }))
              }
              {!isLoading && influencers === undefined && <tr><td colSpan={6}><h1 className='text-center'>Sağ üstten arama yapınız...</h1></td></tr>}
              
              
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
</>)


}

export default ListTable